<template>
  <b-modal
    id="commentsModal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    size="md"
    :visible="isCommentsModal"
    @hidden="$emit('close-modal')"
  >
    <div class="d-flex align-items-center justify-content-between">
      <div class="newJD-modal-head" style="text-transform: capitalize">
        Job Position Status
      </div>
      <div>
        <img
          @click="$emit('close-modal')"
          src="../../../assets/New-imgs/teams-icons/teams-close-icon.svg"
          alt=""
          class="pointer rotate-on-hover"
        />
      </div>
    </div>
    <hr />
    <div class="mt-3">
      <div class="topDiv">
        <label class="teams-label-font"
          >Comments <span class="asterik">*</span></label
        >
        <b-form-textarea
          class="teams-inputField"
          placeholder="Enter"
          v-model.trim="$v.comment.$model"
          :class="{ error: $v.comment.$error }"
          rows="3"
          max-rows="7"
          no-resize
        ></b-form-textarea>
        <div
          v-if="$v.comment.$dirty && !$v.comment.required"
          class="errortxt position-absolute"
        >
          Required
        </div>
        <div
          v-else-if="!$v.comment.maxLength"
          class="errortxt position-absolute"
        >
          Exceeded the max char length of 256
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end mt-5">
      <b-button @click="$emit('close-modal')" class="acs-cancelBtn-modal mr-3"
        >Cancel</b-button
      >
      <div class="position-relative">
        <div class="addpanellog position-relative">
          <b-button
            class="acs-addBtn-modal pl-4 pr-4"
            @click="buttonLoader ? '' : saveComments()"
            :class="buttonLoader ? 'givefeed-loader-class' : 'pointer'"
          >
            <span v-if="!buttonLoader"> Save </span>
          </b-button>

          <div v-if="buttonLoader" class="loader-pos">
            <Loader />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import Loader from "../../../components/fixedcomponents/Loader.vue";

export default {
  name: "CommentsModal",
  data() {
    return {
      comment: "",
    };
  },
  validations() {
    return {
      comment: {
        required,
        maxLength: maxLength(256),
      },
    };
  },
  props: {
    isCommentsModal: Boolean,
    buttonLoader: Boolean,
  },
  components: {
    Loader,
  },
  methods: {
    saveComments() {
      this.$v.comment.$touch();
      if (!this.$v.comment.$invalid) {
        this.$emit("save-comment", this.comment);
      }
    },
  },
};
</script>

<style scoped>
.newJD-modal-body-text {
  font-family: "Lato", sans-serif;
  font-size: 16px;
  line-height: 30px;
  color: #333333;
}
.topDiv > .error {
  border: 1px solid red !important;
  border-radius: 0px;
}
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}
.givefeed-loader-class {
  opacity: 0.5;
  height: 32px;
  width: 95px;
}
</style>
